import Div from "@jumbo/shared/Div";
import { Button, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { BASE_URL } from "app/services/auth-services";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { DateFormatter, formatIndianNumber } from "app/shared/ReuseComponents/DateFormatter";
import WorkflowApproverStatus from "app/shared/ReuseComponents/WorkflowApproverStatus";
import * as XLSX from 'xlsx';
import { useReactToPrint } from "react-to-print";
import { BiSolidFilePdf } from "react-icons/bi";
import { FoyerCloseButton } from "app/shared/ReuseComponents/ButtonComponent";
import PropTypes from "prop-types";


const OverviewFullandFinalSettlement = ({ setOverviewSettlement, setCurrent, currentSettlement }) => {
    const token = localStorage.getItem("accesstoken");
    const header = {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    };

    const componentPDF = useRef();
    const [printPDFForm, setPrintPDFForm] = useState(false);

    const [approvalStatus, setApprovalStatus] = useState([]);


    const [employeeData, setEmployeeData] = useState(null);
    // saved data after create full and final settlement
    const [tableData, setTableData] = useState({
        salaryDetails: [],
        gratuity: 0,
        leaveEncashment: 0,
        reimbursement: {},
        totalEarnings: 0,
        providentFund: 0,
        professionalTax: 0,
        esi: 0,
        incomeTax: "",
        totalDeductions: 0,
        netSettlement: 0,
    });


    const handleAfterPrint = () => {
        console.log('Print completed!');
        setOverviewSettlement(true);
        setPrintPDFForm(false);
    };


    const SaveAsPDF = useReactToPrint({
        content: () => componentPDF?.current,
        documentTitle: '',
        onAfterPrint: handleAfterPrint, // Action after printing
        onPrintError: (error) => console.log("error", error),
        pageStyle: `
          @page {
            size: landscape;
          }
        `,
        removeAfterPrint: true, // Remove content after printing
    });


    const getEmployeeSettlement = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/Felix/FullandFinalCRUD/?id=${currentSettlement?.id}`, header);
            if (response) {
                setEmployeeData(response?.data);
                setTableData(response?.data?.Salary_Details);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getEmployeeSettlement();
    }, [currentSettlement?.id]);

    useEffect(async () => {
        // get approval status
        await axios
            .get(
                `${BASE_URL}/Felix/Purchaserequestworkflow/?Request_Id=${currentSettlement?.FullandFinal_Id}`
            )
            .then((res) => {
                console.log("REE", res?.data);
                setApprovalStatus(res?.data[0]?.Approve);
            })
            .catch((res) => {
                console.log(res.message);
            });
    }, [])


    const handleClickCancel = () => {
        setCurrent(true);
        setOverviewSettlement(false);
    };

    const WorkflowName = "Full and Final Settlement";


    return (
        <div>
            <Typography variant="h3">Overview Full and Final Settlement</Typography>

            <Div sx={{ display: "flex", justifyContent: "end" }}>
                <Button
                    className={"PDF-Excel-Button"}
                    sx={{
                        minWidth: "110px !important",
                        height: "34px !important",
                        "&:hover": {
                            bgcolor: "#017890 !important",
                            color: "white !important",
                        },
                    }}
                    variant={"outlined"}
                    startIcon={<BiSolidFilePdf size={22} />}
                    onClick={() => {
                        setPrintPDFForm(true);
                        setTimeout(() => {
                            SaveAsPDF();
                        }, 500)
                    }}
                >
                    PDF
                </Button>
            </Div>
            <Div ref={componentPDF} sx={{ minHeight: "400px" }}>
                {printPDFForm && <Typography variant="h3" fontWeight={600}>Overview Full and Final Settlement</Typography>}

                {employeeData && (
                    <>
                        <Div sx={{ mt: 2, mb: 1 }}>
                            <Grid container spacing={{ xs: 1, md: 2 }}>
                                <Grid item xs={printPDFForm ? 6 : 12} md={6}>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography variant="h5">Name of Employee</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="h5">: {employeeData?.Employee_Name}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography variant="h5">Department</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="h5">: {employeeData?.Department}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography variant="h5">Resignation Date</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="h5">
                                                : <DateFormatter date={employeeData?.Date_Of_Resignation} />
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography variant="h5">Relieving Date</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="h5">
                                                : <DateFormatter date={employeeData?.Releiving_Date} />
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={printPDFForm ? 6 : 12} md={6}>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography variant="h5">Employee Code</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="h5">: {employeeData?.Employee_Id}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography variant="h5">Reporting To</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="h5">: {employeeData?.Reporting_To}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography variant="h5">Acceptance Date</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="h5">
                                                : <DateFormatter date={employeeData?.Acceptance_Date} />
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Div>

                        <Div
                            id="no-more-tables"
                            sx={{ height: printPDFForm ? 'auto' : '300px', width: printPDFForm ? "90%" : "100%", overflowY: printPDFForm ? "visible" : "scroll", scrollBehavior: "smooth" }}
                        >
                            <Table stickyHeader className="table">
                                <TableHead className="table-head">
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell>Month</TableCell>
                                        <TableCell>Days</TableCell>
                                        <TableCell className="Amount_Fields">Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableData?.salaryDetails && tableData?.salaryDetails?.length > 0 ? (
                                        (() => {
                                            return (
                                                <>
                                                    {tableData?.salaryDetails?.map((data, index) => (
                                                        <React.Fragment key={index}>
                                                            <TableRow key={`earnings-${index}`}>
                                                                <TableCell data-title="">Salary</TableCell>
                                                                <TableCell data-title="Month">
                                                                    {data?.month || 'N/A'}
                                                                </TableCell>
                                                                <TableCell data-title="Days">{data?.days || 'N/A'}</TableCell>
                                                                <TableCell data-title="Amount" className="Amount_Fields">
                                                                    {formatIndianNumber(data?.amount) || 0}
                                                                </TableCell>
                                                            </TableRow>
                                                        </React.Fragment>
                                                    ))}

                                                    <TableRow>
                                                        <TableCell data-title="">Gratuity</TableCell>
                                                        <TableCell data-title="Month"></TableCell>
                                                        <TableCell data-title="Days"></TableCell>
                                                        <TableCell data-title="Amount" className="Amount_Fields">
                                                            {formatIndianNumber(tableData?.gratuity)}
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell data-title="">Leave Encashment</TableCell>
                                                        <TableCell data-title="Month"></TableCell>
                                                        <TableCell data-title="Days"></TableCell>
                                                        <TableCell data-title="Amount" className="Amount_Fields">
                                                            {formatIndianNumber(tableData?.leaveEncashment)}
                                                        </TableCell>
                                                    </TableRow>

                                                    {Object.entries(tableData?.reimbursement || {}).length > 0 && (
                                                        <TableRow>
                                                            <TableCell data-title="" sx={{ fontWeight: 600 }}>Reimburshment</TableCell>
                                                            <TableCell data-title="Month"></TableCell>
                                                            <TableCell data-title="Days"></TableCell>
                                                            <TableCell data-title="Amount" className="Amount_Fields">
                                                            </TableCell>
                                                        </TableRow>
                                                    )}

                                                    {Object.entries(tableData?.reimbursement || {}).map(([key, opt], index) => (
                                                        <TableRow key={index}>
                                                            <TableCell data-title="">{key}</TableCell>
                                                            <TableCell data-title="Month"></TableCell>
                                                            <TableCell data-title="Days"></TableCell>
                                                            <TableCell data-title="Amount" className="Amount_Fields">
                                                                {formatIndianNumber(opt?.reimbursement)}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}

                                                    <TableRow>
                                                        <TableCell data-title="" sx={{ fontWeight: 600 }}>Total Earnings (A)</TableCell>
                                                        <TableCell data-title="Month"></TableCell>
                                                        <TableCell data-title="Days"></TableCell>
                                                        <TableCell data-title="Amount" className="Amount_Fields">
                                                            {formatIndianNumber(tableData?.totalEarnings)}
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell data-title="" sx={{ fontWeight: 600 }}>Provident Fund</TableCell>
                                                        <TableCell data-title="Month"></TableCell>
                                                        <TableCell data-title="Days"></TableCell>
                                                        <TableCell data-title="Amount" className="Amount_Fields">
                                                            {formatIndianNumber(tableData?.providentFund)}
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell data-title="" sx={{ fontWeight: 600 }}>Professional Tax</TableCell>
                                                        <TableCell data-title="Month"></TableCell>
                                                        <TableCell data-title="Days"></TableCell>
                                                        <TableCell data-title="Amount" className="Amount_Fields">
                                                            {formatIndianNumber(tableData?.professionalTax)}
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell data-title="" sx={{ fontWeight: 600 }}>ESI</TableCell>
                                                        <TableCell data-title="Month"></TableCell>
                                                        <TableCell data-title="Days"></TableCell>
                                                        <TableCell data-title="Amount" className="Amount_Fields">
                                                            {formatIndianNumber(tableData?.esi)}
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell data-title="">Income Tax(TDS)</TableCell>
                                                        <TableCell data-title="Month"></TableCell>
                                                        <TableCell data-title="Days"></TableCell>
                                                        <TableCell data-title="Amount" className="Amount_Fields">
                                                            {formatIndianNumber(tableData?.incomeTax)}
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell data-title="">Miscellaneous Earning</TableCell>
                                                        <TableCell data-title="Month"></TableCell>
                                                        <TableCell data-title="Days"></TableCell>
                                                        <TableCell data-title="Amount" className="Amount_Fields">
                                                            {formatIndianNumber(tableData?.mislinieseEarning)}
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell data-title="">Miscellaneous Deduction</TableCell>
                                                        <TableCell data-title="Month"></TableCell>
                                                        <TableCell data-title="Days"></TableCell>
                                                        <TableCell data-title="Amount" className="Amount_Fields">
                                                            {formatIndianNumber(tableData?.mislinieseDeduction)}
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell data-title="" sx={{ fontWeight: 600 }}>Total Deductions (B)</TableCell>
                                                        <TableCell data-title="Month"></TableCell>
                                                        <TableCell data-title="Days"></TableCell>
                                                        <TableCell data-title="Amount" className="Amount_Fields">
                                                            {formatIndianNumber(tableData?.totalDeductions || 0)}
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell data-title="" sx={{ fontWeight: 600 }}>Net Settlement Dues</TableCell>
                                                        <TableCell data-title="Month"></TableCell>
                                                        <TableCell data-title="Days"></TableCell>
                                                        <TableCell data-title="Amount" className="Amount_Fields">
                                                            {formatIndianNumber(tableData?.netSettlement)}
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            );
                                        })()
                                    ) : (
                                        <TableRow>
                                            <TableCell className="text-left" colSpan={4}>No Records</TableCell>
                                        </TableRow>
                                    )}

                                </TableBody>
                            </Table>
                        </Div>
                    </>
                )}

                {/* workflow status */}
                <Div sx={{ mt: 2, width: printPDFForm ? "90%" : "100%" }}>
                    <WorkflowApproverStatus WorkflowName={WorkflowName} partnerId={currentSettlement?.Partner_Id?.id} approvalStatus={approvalStatus} />
                </Div>
            </Div>

            <Div sx={{ mt: { xs: 3, md: 2 } }}>
                <FoyerCloseButton onClick={handleClickCancel} />
            </Div>
        </div>
    )
}

OverviewFullandFinalSettlement.propTypes = {
    setOverviewSettlement: PropTypes.func,
    setCurrent: PropTypes.func,
    currentSettlement: PropTypes.object,
}

export default OverviewFullandFinalSettlement
